import {
  Component,
  EventEmitter,
  input,
  Input,
  model,
  OnInit,
  output,
  Output,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { Types } from 'shared-lib';
import { EComponentSize, EIcon } from '../../types';
import { IconComponent } from '../icon/icon.component';

@Component({
  selector: 'ui-circular-progress',
  standalone: true,
  imports: [CommonModule, IconComponent],
  templateUrl: './circular-progress.component.html',
  styleUrls: ['./circular-progress.component.scss'],
})
export class CircularProgressComponent implements OnInit {
  percentage = input<number>(0);
  color = input<Types.EAlert>(Types.EAlert.INFO);
  size = input<EComponentSize>(EComponentSize.Medium);
  icon = input<EIcon>();
  title = input<string>();
  clickable = input(false);

  action = output<void>();

  EIcon = EIcon;
  animatedPercentage: number = 0;
  progressStrokeDash: number = 0;
  readonly radius = 50;
  readonly circumference = 2 * Math.PI * this.radius;

  ngOnInit() {
    this.animateProgress();
  }

  animateProgress() {
    const totalFrames = 50;
    const step = this.percentage() / totalFrames;
    let current = 0;

    const interval = setInterval(() => {
      if (current >= this.percentage()) {
        clearInterval(interval);
      } else {
        current += step;
        let aux = Math.min(current, this.percentage());
        this.animatedPercentage = aux;
        this.progressStrokeDash = (aux / 100) * this.circumference;
      }
    }, 50);
  }

  emitClick() {
    if (this.clickable()) {
      this.action.emit();
    }
  }

  get circleClass(): string {
    let circleSize = this.getSize();
    let circleCursor = this.cursorClass();
    return `relative ${circleSize} ${circleCursor}`;
  }

  get progressColor(): string {
    switch (this.color()) {
      case Types.EAlert.SUCCESS:
        return 'text-green-500 stroke-green-500';
      case Types.EAlert.DANGER:
        return 'text-red-500 stroke-red-500';
      case Types.EAlert.WARNING:
        return 'text-yellow-500 stroke-yellow-500';
      case Types.EAlert.DARK:
        return 'text-gray-900 stroke-gray-900';
      case Types.EAlert.LIGHT:
        return 'text-white-900 stroke-white-900';
      default:
        return 'text-blue-500 stroke-blue-500';
    }
  }

  getSize(): string {
    const sizeClasses: Record<EComponentSize, string> = {
      [EComponentSize.Small]: 'w-24 h-24',
      [EComponentSize.Medium]: 'w-32 h-32',
      [EComponentSize.Large]: 'w-40 h-40',
      [EComponentSize.ExtraLarge]: 'w-48 h-48',
    };

    return sizeClasses[this.size()] || '';
  }

  get textSize(): string {
    return this.size() === EComponentSize.Large ? 'text-2xl' : 'text-xl';
  }

  cursorClass(): string {
    return this.clickable() ? 'cursor-pointer' : 'cursor-default';
  }
}
